import React from "react";
import {useTranslation} from 'react-i18next';
import {createTheme, Grid, Typography, Switch, FormControlLabel} from '@mui/material';
import Post from "./Post";
import {NewPost, Comment} from "./NewPost";
import axios from "axios";

// ------------------------------- STYLING -------------------------------
const theme = createTheme();

theme.typography.h3 = {
    fontFamily: 'Georgia',
    fontWeight: '400',
    fontSize: '24px',
    color: '#333333',
    margin: '0 0 5em 0',
    textDecoration: "none",
    boxShadow: "none",
    display: 'inline-block',
    '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    '@media (max-width:800px)': {
        fontSize: '18px',
    },
};
theme.typography.h4 = {
    fontFamily: 'Georgia',
    fontWeight: '700',
    fontSize: '24px',
    color: '#BC7200',
    margin: '3em 0 3em 0',
    textDecoration: "none",
    boxShadow: "none",
    display: 'inline-block',
    '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    '@media (max-width:800px)': {
        fontSize: '18px',
    },
};
theme.typography.h5 = {
    fontFamily: 'Georgia',
    fontWeight: '700',
    fontSize: '16px',
    color: '#BC7200',
    margin: '3em 0 0 0',
    display: 'inline-block',
    '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
};

const heading = {
    fontStyle: 'normal',
    color: '#020404',
    margin: '2em 0 1em 0',
    fontFamily: 'Montserrat',
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '24px',
    letterSpacing: '0.03em',
}
// ------------------------------- STYLING -------------------------------


// ------------------------------- POSTS ARRAY -------------------------------
/*const posts = [
    {
        title: "Lessons on Facebook and Chance to Go to London — How Recruiters Learn English",
        preview: "A case study from ANTAL Russia, British recruitment agency with branches all over the world including Russia",
        pic: picture,
        profilepic: picture2,
        author: "Paul Thomas",
        date: "Mar 17",
        readtime: 8
    },
    {
        title: "Lessons on Facebook and Chance to Go to London — How Recruiters Learn English",
        preview: "A case study from ANTAL Russia, British recruitment agency with branches all over the world including Russia",
        pic: picture,
        profilepic: picture2,
        author: "Paul Thomas",
        date: "Mar 17",
        readtime: 8
    },
    {
        title: "Lessons on Facebook and Chance to Go to London — How Recruiters Learn English",
        preview: "A case study from ANTAL Russia, British recruitment agency with branches all over the world including Russia",
        pic: picture,
        profilepic: picture2,
        author: "Paul Thomas",
        date: "Mar 17",
        readtime: 8
    },
    {
        title: "Lessons on Facebook and Chance to Go to London — How Recruiters Learn English",
        preview: "A case study from ANTAL Russia, British recruitment agency with branches all over the world including Russia",
        pic: picture,
        profilepic: picture2,
        author: "Paul Thomas",
        date: "Mar 17",
        readtime: 8
    },
]*/
// ------------------------------- POSTS ARRAY -------------------------------


// let posts;


/*let config = {
    method: 'get',
    url: 'http://localhost:3000/post',
    headers: {}
};

axios(config)
    .then(function (response) {
        console.log(JSON.stringify(response.data));

    })a
    .catch(function (error) {
        console.log(error);
    });*/


const Content = ({
                     axiosPosts, axiosPostsData, axiosUsersRoles, axiosThumbnails, loading,
                     postsDataLoading, thumbnailsLoading, usersrolesLoading, tag, axiosCategories,
                     isSwitchOn, follows, onPostDelete, axiosProfiles, hasMore, onLoadMore,
                     postCategories = {}, sortBy, setSortBy,
                 }) => {
    const {t} = useTranslation();


    //filters will be used to only display posts that fall in a certain category
    // const [filters, setFilters] = useState([])


    // function toggleFilters(name) {
    //     if (filters.includes(name)) {
    //         let index = filters.indexOf(name)
    //         let filtersCopy = [...filters]
    //         filtersCopy.splice(index, 1)
    //         setFilters(filtersCopy)
    //     }
    //     else {
    //         setFilters([...filters, name])
    //     }
    // }

    // function checkSelected(name) {
    //     return filters.includes(name)
    // }

    // function getStyle(check) {
    //     if (check) {
    //         return {backgroundColor: 'lightblue'}
    //     } else {
    //         return {backgroundColor: "transparent"}
    //     }
    // }


    /*return (
        <Container>
            <Grid container justifyContent="space-between" alignItems="stretch" spacing={4} >
                <Grid item xs={12} sm={8}>
                    <Typography style={heading}>{t('AboutPage.Other.OtherPosts')}</Typography>
                    {posts.map((post, idx) => {
                        return <Post info={post}/>
                    })}
                    <div>
                        <ThemeProvider theme={theme}>
                            <Typography variant="h5">
                                {t('AboutPage.Other.More')}
                            </Typography>
                        </ThemeProvider>
                    </div>
                </Grid>
    
                <Grid item xs={12} sm={4} >
                    <Categories/>
                </Grid>
            </Grid>
            <ThemeProvider theme={theme}>
                <div>
                    <Typography variant="h4" component={Link} to="/welcome/products">{t("AboutPage.Products.SP")}</Typography>
                </div>
                <Typography variant="h3" component={Link} to="/welcome/products">{t("AboutPage.Products.Learn")}</Typography>
            </ThemeProvider>
        </Container>
    )*/

    /* Debugging fetched data */
    //console.log('Posts Data = ', fetchedPostsData);
    //console.log('Posts Array Length = ', fetchedPosts.length);
    //console.log(fetchedUserId[0]);
    //console.log('Users = ', fetchedUsers);
    //console.log('Boolean is ', isPostsDataFetched);
    //console.log(capturedHeaders);

    //Creates New Post Object
    let posts = [];
    if (!loading && !usersrolesLoading && !postsDataLoading && !thumbnailsLoading) {
        for (let i = 0; i < axiosPosts.length; i++) {
            if (!axiosPostsData[i]) continue;
            const newPost = new NewPost(
                axiosPosts[i].id, axiosPosts[i].title, axiosPostsData[i]?.postData, axiosPosts[i].subtitle, axiosPosts[i]?.created, axiosPosts[i]?.modified, axiosThumbnails[i], axiosPosts[i].viewcount, axiosPosts[i].userId, axiosPosts[i].translations
            );

            //Runs through every user
            for (let j = 0; j < axiosUsersRoles.length; j++) {

                //Checks if post userid matches with user id
                if (axiosPosts[i]?.userId === axiosUsersRoles[j]?.user?.id) {

                    //Checks if user has a middle name and set it to their fullname
                    if (axiosUsersRoles[j]?.user?.middlename) {
                        let abbreviatedMiddleName = axiosUsersRoles[j]?.user?.middlename.slice(0, 1).concat('.');
                        let fullName = axiosUsersRoles[j]?.user?.firstName + ' '
                            + abbreviatedMiddleName + ' '
                            + axiosUsersRoles[j]?.user?.lastName;
                        newPost.setFullName(fullName);
                    } else {
                        let fullName = axiosUsersRoles[j]?.user?.firstName + ' ' + axiosUsersRoles[j]?.user?.lastName;
                        newPost.setFullName(fullName);
                    }

                    //Set the user's role
                    newPost.setRole(axiosUsersRoles[j]?.roles[0]?.role);
                    // Get profile photo from axiosProfiles using the post author's userId
                    const userProfile = axiosProfiles.find(p => p.userId === axiosPosts[i].userId);
                    newPost.setProfilePhoto(userProfile?.photo || null);


                    /* Put in here for user related stuff */

                }
            }

            //Set how minutes to read for a post
            if (newPost.body) {
                newPost.setReadingTime(newPost.body);
            }

            //Set true or false if post has different modification date and before making changes to the date
            if (newPost.dateCreated !== newPost.dateModified) {
                newPost.setIsEdited(true);
            }
            //Set and Parses date
            newPost.setDateCreated((newPost.dateCreated.slice(0, 10)));
            newPost.setDateModified((newPost.dateModified.slice(0, 10)));

            // Add the post to the array
            posts.push(newPost);
        }
    }

    // Sort posts based on `isSwitchOn` (toggle state)
    if (isSwitchOn) {
        console.log("=== SORT BY FOLLOWED USER ===");
        console.log("follows prop:", follows);
        console.log("axiosPosts:", axiosPosts.map(p => ({ id: p.id, userId: p.userId })));

        // Extract followed user IDs from the follows array (which contains objects with followed_id)
        const followedUserIds = Array.isArray(follows)
            ? follows.map(f => f.followed_id)
            : [];
        console.log("followedUserIds:", followedUserIds);

        // Create arrays for followed and non-followed posts
        let followedPosts = [];
        let nonFollowedPosts = [];

        // Map axiosPosts' userId to corresponding posts
        for (let i = 0; i < axiosPosts.length; i++) {
            const axiosPost = axiosPosts[i];

            // Find the corresponding post in posts using id getter
            const matchingPost = posts.find(post => post.id === axiosPost.id);

            if (matchingPost) {
                // Check if the post's userId is in the followed user IDs
                const isFollowed = followedUserIds.includes(axiosPost.userId);
                console.log(`Post ${axiosPost.id} by user ${axiosPost.userId} - isFollowed: ${isFollowed}`);
                if (isFollowed) {
                    followedPosts.push(matchingPost);
                } else {
                    nonFollowedPosts.push(matchingPost);
                }
            }
        }

        // Clear the original posts array
        posts.length = 0;

        // Combine followed and non-followed posts into posts
        posts.push(...followedPosts, ...nonFollowedPosts);

        console.log("Sorted Posts (followed first):", followedPosts.length, "followed,", nonFollowedPosts.length, "other");
        console.log("=== END SORT ===");

    } else {
        console.log("Sorting by date...");

        //Reverse array to display newest to oldest
        let postTempArr = [];
        for (let i = 0; i < posts.length; i++) {
            postTempArr[i] = posts[i];
        }
        let j = postTempArr.length - 1;
        for (let i = 0; i < postTempArr.length; i++) {
            posts[i] = postTempArr[j];
            j--;
        }
    }

    /*for (let i = 0; i < posts.length; i++) {
        console.log('Post ', i, ' = ', posts[i]);
    }*/

    // Set actual categories for each post from postCategories map
    posts.forEach(post => {
        const categories = postCategories[post.id] || [];
        if (categories.length > 0) {
            // Set the first category as the main tag for display
            post.setTag(categories[0]);
            // Store all categories for filtering
            post.categories = categories;
        }
    });

    //If category exists, filter posts by checking if any of the post's categories match
    if (tag) {
        posts = posts.filter((post) => {
            const categories = post.categories || [];
            // Check if any category matches by id or name
            return categories.some(cat =>
                cat.id === tag.id ||
                cat.categoryId === tag.id ||
                cat.name === tag.name
            );
        });
    }

    return (
        <>
            <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: '0.5rem' }}>
                <Grid item>
                    <Typography style={heading}>
                        {t('Articles')}
                    </Typography>
                </Grid>
                <Grid item>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={sortBy === 'followed_user'}
                                onChange={() => setSortBy(sortBy === 'date' ? 'followed_user' : 'date')}
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: '#6750A4',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: '#6750A4',
                                    },
                                }}
                            />
                        }
                        label={
                            <span style={{
                                fontFamily: 'Montserrat, sans-serif',
                                fontSize: '0.85rem',
                                color: '#49454F',
                                fontWeight: 500
                            }}>
                                {sortBy === 'date' ? t('Sort by Date') : t('Following First')}
                            </span>
                        }
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} direction={"column"}>
                <Grid item xs={12}>
                    <Post posts={posts} loading={loading} usersrolesLoading={usersrolesLoading}
                          postsDataLoading={postsDataLoading} thumbnailsLoading={thumbnailsLoading} tag={tag}
                          hasMore={hasMore} onLoadMore={onLoadMore} onPostDelete={onPostDelete} />
                </Grid>
            </Grid>
            {/*<img src={greydash} className='dash' alt=""/>*/}
        </>
    )

}

export default Content
